import { render, staticRenderFns } from "./BlockBlogListEmptyBlock.vue?vue&type=template&id=ba4dc826&scoped=true&"
import script from "./BlockBlogListEmptyBlock.vue?vue&type=script&lang=js&"
export * from "./BlockBlogListEmptyBlock.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlogListEmptyBlock.vue?vue&type=style&index=0&id=ba4dc826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4dc826",
  null
  
)

export default component.exports